export default __webpack_public_path__ + "static/media/map_viewer.df05edef.png";